module.exports = __webpack_public_path__ + "static/img/biankuang_m02.4e45ad0.png";


//////////////////
// WEBPACK FOOTER
// ./static/biankuang_m02.png
// module id = wTaB
// module chunks = 1